import Checkbox from 'containers/UpdatesV2/components/commons/Checkbox'
import styled from 'styled-components'

export const StyledCheckbox = styled(Checkbox)`
  margin-bottom: 0.5rem;
`
